import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import styles from 'features/auth/ui/Auth/Auth.module.scss';
import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import Box from 'shared/ui/Box/Box';
import Button from 'shared/ui/Button/Button/Button';

import useConfirmDeletion from '../../model/useConfirmDeletion';

const ConfirmDeletionScreen: React.FC = () => {
    const {handleContinue} = useConfirmDeletion();

    return (
        <BlankLayout>
            <div className={styles.wrapper}>
                <div className={styles.box_wrapper_confirm}>
                    <Box>
                        <div className="row text-center mb-3">
                            <div className="col-12">
                                <h2 className={styles.title}>{t`Удаление аккаунта`}</h2>
                                <p className={cn('py-2 m-0', styles.confirm_email__msg)}>
                                    {t`Аккаунт успешно удалён`}
                                </p>
                            </div>
                        </div>

                        <Button
                            onClick={handleContinue}
                            block
                        >
                            {t`Продолжить`}
                        </Button>
                    </Box>
                </div>
            </div>
        </BlankLayout>
    );
};

export default ConfirmDeletionScreen;
